import {createContext, use, type ReactNode} from 'react'
import {createPortal} from 'react-dom'
import {clsx} from 'clsx'

import styles from './AgentsWorkbench.module.css'

export const AgentsWorkbenchHeaderContext = createContext<HTMLElement | null | undefined>(undefined)

export function AgentsWorkbenchHeader({
  children,
  padded = false,
  hidden = false,
}: {
  children: ReactNode
  padded?: boolean
  hidden?: boolean
}) {
  const target = use(AgentsWorkbenchHeaderContext)
  // Keep the existing header during SSR and hydration until the host target mounts.
  if (!target) return children
  return createPortal(
    <div className={clsx(styles.headerMount, padded && styles.paddedHeader)} hidden={hidden}>
      {children}
    </div>,
    target,
  )
}
